import React, { createContext, useContext, useState, useCallback } from 'react';
import { X, CheckCircle2, AlertTriangle, Info } from 'lucide-react';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = 'info', duration = 4000) => {
    // Toast notifications are disabled site-wide to avoid showing alerts to visitors
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {/* Toast Portal Container */}
      <div className="fixed top-6 right-6 z-[9999] flex flex-col gap-3 w-full max-w-sm pointer-events-none">
        {toasts.map((toast) => (
          <div
            key={toast.id}
            className={`pointer-events-auto flex items-start gap-3 p-4 rounded-2xl border backdrop-blur-md transition-all duration-300 transform translate-y-0 shadow-[0_10px_30px_rgba(0,0,0,0.08)] ${
              toast.type === 'success'
                ? 'bg-emerald-50/90 border-emerald-100/80 text-emerald-800'
                : toast.type === 'error'
                ? 'bg-rose-50/90 border-rose-100/80 text-rose-800'
                : 'bg-zinc-50/90 border-zinc-100/80 text-zinc-800'
            }`}
          >
            {/* Status Icons */}
            {toast.type === 'success' && <CheckCircle2 size={16} className="text-emerald-500 shrink-0 mt-0.5" />}
            {toast.type === 'error' && <AlertTriangle size={16} className="text-rose-500 shrink-0 mt-0.5" />}
            {toast.type === 'info' && <Info size={16} className="text-zinc-500 shrink-0 mt-0.5" />}

            {/* Content */}
            <div className="flex-1 text-xs font-semibold leading-relaxed">
              {toast.message}
            </div>

            {/* Dismiss Button */}
            <button
              onClick={() => removeToast(toast.id)}
              className="text-zinc-400 hover:text-zinc-600 transition-colors p-0.5 rounded-lg hover:bg-black/5"
            >
              <X size={14} />
            </button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
}
